/** Convert UI format "9:00am" to 24h "09:00" */
export function to24h(time12: string): string {
	const match = time12.match(/^(\d+):(\d{2})(am|pm)$/i);
	if (!match) return '09:00';
	let h = parseInt(match[1], 10);
	const m = match[2];
	const period = match[3].toLowerCase();
	if (period === 'am') {
		if (h === 12) h = 0;
	} else {
		if (h !== 12) h += 12;
	}
	return `${String(h).padStart(2, '0')}:${m}`;
}

/** Get today's date as YYYY-MM-DD */
export function today(): string {
	return new Date().toISOString().split('T')[0];
}

/** Convert 24h "09:00" to UI format "9:00am" */
export function to12h(time24: string): string {
	const [hStr, mStr] = time24.split(':');
	const h = parseInt(hStr, 10);
	const m = parseInt(mStr, 10);
	if (isNaN(h) || isNaN(m)) return '9:00am';
	const period = h < 12 ? 'am' : 'pm';
	const hour = h === 0 ? 12 : h > 12 ? h - 12 : h;
	const min = m === 0 ? '00' : '30';
	return `${hour}:${min}${period}`;
}

/** Generate half-hour time options for a full day (12:00am – 11:30pm) */
export function generateTimeOptions(): { value: string; label: string }[] {
	const options: { value: string; label: string }[] = [];
	for (let h = 0; h < 24; h++) {
		for (const m of [0, 30]) {
			const period = h < 12 ? 'am' : 'pm';
			const displayHour = h === 0 ? 12 : h > 12 ? h - 12 : h;
			const displayMin = m === 0 ? '00' : '30';
			const label = `${displayHour}:${displayMin}${period}`;
			options.push({ value: label, label });
		}
	}
	return options;
}
